import * as api from '../../services/dynamic'

export const FETCH_BROADCASTS= 'FETCH_BROADCASTS';




export const fetchBroadcasts = (params, pagination, sort, extra) => {

    return {
        type: FETCH_BROADCASTS,
        payload: {
            promise: api.findBroadcasts(Object.assign({}, params, {page: pagination ? pagination.current : 1, pageSize: pagination ? pagination.pageSize : 20})),
        },
        meta: {
            searchParams: params,
            sort: sort,
            extra: extra
        }
    };
};



// WEBPACK FOOTER //
// ./src/redux/actions/dynamic.js